import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LOGIN_URL } from '../api/axiosClient';
import styles from '../static/styles/Rewards.module.css';
import { redeemReward } from '../api/rewards';
import weeklyTournamentBg from '../static/img/WeeklyTournaments/imagePubgWeeklyTournament.avif';
import freeFireIcon from '../static/img/DailyGamingTasks/iconFreeFireDailyTasks.avif';
import { getRewardsList } from '../api/rewards';

import MessagePopup from '../components/MessagePopup';

import playstation5Img from '../static/img/Rewards/Playstation5.avif';
import asusRogStrixGoImg from '../static/img/Rewards/AsusROGStrixGoUSBCGamingHeadset.avif';
import asusRogDeltaSCoreImg from '../static/img/Rewards/AsusROGDeltaSCoreGamingHeadphone.avif';
import edifierG1Img from '../static/img/Rewards/EdifierUSBGamingHeadsetG2.avif';
import edifierG2Img from '../static/img/Rewards/EdifierUSBGamingHeadsetG2.avif';
import asusTufKeyboardImg from '../static/img/Rewards/bloody_keyboard.avif';
import bloodyB760Img from '../static/img/Rewards/bloody_keyboard.avif';
import bloodyB865NImg from '../static/img/Rewards/BloodyMechanicalGamingKeyboardB865N.avif';
import asusGladiusImg from '../static/img/Rewards/AsusROGGladiusIIIP514GamingMouse.avif';
import asusKerisImg from '../static/img/Rewards/AsusROGKerisP509GamingMouse.avif';
import pubgImg from '../static/img/Rewards/pubgReward.jpg';
import fortniteImg from '../static/img/Rewards/fortniteReward.avif';
import minecraftImg from '../static/img/Rewards/mirecraft_Reward.jpg';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../api/auth';
import { jwtDecode } from 'jwt-decode';
import GameNowPopup from '../components/GameNowPopup';


const Rewards = () => {
    const { t } = useTranslation();
    const [message, setMessage] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [showGameNow, setShowGameNow] = useState(false);
    const [rewardsData, setRewardsData] = useState([]);
    const [loadingRewards, setLoadingRewards] = useState(true);
    const [errorRewards, setErrorRewards] = useState(null);
    const navigate = useNavigate();

    const getRewardImage = (rewardId) => {
        switch (rewardId) {
            case 1: return playstation5Img; // Playstation 5
            case 2: return asusRogDeltaSCoreImg; // Asus ROG Gaming Headphone
            case 3: return edifierG1Img; // Edifier USB Gaming Headset
            case 4: return asusTufKeyboardImg; // Asus Gaming Keyboard
            case 5: return bloodyB760Img; // Bloody Mechanical Gaming Keyboard
            case 6: return asusGladiusImg; // Asus ROG Gaming Mouse
            case 7: case 8: case 9: case 10: return pubgImg; // PUBG Mobile UC
            case 11: case 12: case 13: return fortniteImg; // Fortnite V-Bucks
            case 14: case 15: return minecraftImg; // Minecraft Minecoins
            default: return '';
        }
    };

    useEffect(() => {
        document.title = `${t('rewards')} | Esl`
    }, [t])

    useEffect(() => {
        const loadRewards = async () => {
            try {
                setLoadingRewards(true);
                setErrorRewards(null);
                const response = await getRewardsList();
                if (response && response.data && Array.isArray(response.data)) {
                    setRewardsData(response.data);
                } else {
                    setRewardsData([]);
                }
            } catch (err) {
                setErrorRewards(err.message || t('failed_load_rews'));
            } finally {
                setLoadingRewards(false);
            }
        };
        loadRewards();
    }, []);

    const handleRedeem = async (rewardIndex) => {
        try {
            if (!isAuthenticated()) {
                window.location.href = LOGIN_URL;
                return;
            }

            const accessToken = localStorage.getItem("access_token");
            const decoded = jwtDecode(accessToken);

            if (decoded.gn) {
                if (decoded.gn === 1) {
                    setShowGameNow(true)
                    return;
                }
            }
            const response = await redeemReward(rewardIndex);

            if (response.status === 200) {
                if (response.data.success) {
                    navigate('/redeem', { state: { reward: response.data.data } });
                } else if (response.data?.data.details) {
                    setMessage(response.data?.data.details);  // ???
                    setIsPopupOpen(true);
                } else if (response.data?.data.message) {
                    setMessage(response.data?.data.message);
                    setIsPopupOpen(true);
                } else {
                    setMessage(t('err_long'));
                    setIsPopupOpen(true);
                }
            }
        } catch (error) {
            setMessage(error.data?.message || t('err_long'));
            setIsPopupOpen(true);
            // console.log(error);
        } finally {
        }
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setMessage(null);
    };


    return (
        <div className={styles.container}>
            <h2 className={styles.heading}>{t('rewards')}</h2>
            <p className={styles.subheading}>{t('rews_msg_1')}</p>

            {loadingRewards && <div className={styles.loading}>{t('loading')}</div>}
            {errorRewards && <div className={styles.error}>{t('err')}: {errorRewards}</div>}

            {!loadingRewards && !errorRewards && (
                <div className={styles.cardGrid}>
                    {rewardsData.map((reward, index) => (
                        <div key={reward.id || reward.name} className={styles.cardWrapper}>
                            <div className={styles.card}>
                                <div
                                    className={styles.cardContent}
                                    style={{ backgroundImage: `url(${getRewardImage(reward.id)})` }}
                                >
                                    <div className={styles.bottomContent}>
                                        <div className={styles.prizeInfo}>
                                            <h3>{reward.name}</h3>
                                            <p>{t('creds_to_win', { credits: reward.credits ? reward.credits.toLocaleString() : 'N/A' })}</p>
                                        </div>
                                        {/* <div className={styles.gameIcon}>
                                            <img src={freeFireIcon} alt="Game Icon" />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            <button className={styles.redeemButton} onClick={() => handleRedeem(index)}>{t('redeem')}</button> {/* Redeem button below the card */}
                        </div>
                    ))}
                </div>
            )}
            {isPopupOpen && <MessagePopup
                isOpen={isPopupOpen}
                message={message}
                onClose={handleClosePopup}
            />}

            {showGameNow && <GameNowPopup isOpen={showGameNow} onClose={() => { setShowGameNow(false) }} />}
        </div>
    );
};

export default Rewards;